<template>
  <Navbar :center-text="$t('TrainingResourcesView.trainingResources')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>
  <div class="p-4 w-100">

    <div class="row align-content-end justify-content-end"
         v-if="sharedState.user_isAdmin">
      <div class="col-2 mb-1">
        <button class="btn btn-warning"
                v-if="!isEditing"
                @click="startEditing">
          <i class="bi bi-pencil"></i>
          {{ $t('edit') }}
        </button>
        <button class="btn btn-success mx-1"
                v-if="isEditing"
                @click.prevent="saveEdits">
          <i class="bi bi-plus-circle"></i>
          {{ $t('save') }}
        </button>
      </div>
    </div>

    <div class="row justify-content-start">
      <div class="col-md-3 p-1">
        <div class="border border-brown card-yellow" style="min-height:100%;">

          <div class="rounded border border-brown m-3 p-2 card-beige">
            <TrainingResourceCategoryComponent
                v-if="resources !== undefined && resources !== null && resources.constructor === Object"
                :resources="resources['principles']"
                :header="$t('TrainingResourcesView.principles')"
                :is-editing="isEditing"></TrainingResourceCategoryComponent>
          </div>

          <div class="rounded border border-brown m-3 p-2  card-beige">
            <TrainingResourceCategoryComponent
                v-if="resources !== undefined && resources !== null && resources.constructor === Object"
                :resources="resources['benefits']"
                :header="$t('TrainingResourcesView.benefits')"
                :is-editing="isEditing"></TrainingResourceCategoryComponent>
          </div>
        </div>
      </div>

      <div class="col-md-2 p-1">
        <div class="border border-brown card-yellow" style="min-height:100%;">
          <h2>{{ $t('TrainingResourcesView.whatAreYouDoingNow') }}</h2>
          <p>{{ $t('TrainingResourcesView.whatAreYouDoingNowText') }}</p>
          <p><strong>{{ $t('TrainingResourcesView.whatAreYouDoingNowText2') }}</strong></p>
          <div class="rounded border border-brown m-3 p-2 card-beige">
            <TrainingResourceCategoryComponent
                v-if="resources !== undefined && resources !== null && resources.constructor === Object"
                :resources="resources['diagnostics']"
                :header="$t('TrainingResourcesView.diagnosticTool')"
                :is-editing="isEditing"></TrainingResourceCategoryComponent>
          </div>
        </div>
      </div>

      <div class="col-md-5 p-1">
        <div class="border border-brown card-yellow" style="min-height:100%;">
          <h2>{{ $t('TrainingResourcesView.whatArePractices')}}</h2>

          <div class="rounded border border-brown m-3 p-2  card-beige">
            <div class="row">
              <div class="col-md-11">
                <div class="row">
                  <div class="col-12">
                    <TrainingResourceCategoryComponent
                        v-if="resources !== undefined && resources !== null && resources.constructor === Object"
                        :resources="resources['coffee']"
                        :header="$t('TrainingResourcesView.agroecologyInCoffee')"
                        :is-editing="isEditing"></TrainingResourceCategoryComponent>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <TrainingResourceCategoryComponent
                        v-if="resources !== undefined && resources !== null && resources.constructor === Object"
                        :resources="resources['cocoa']"
                        :header="$t('TrainingResourcesView.agroecologyInCocoa')"
                        :is-editing="isEditing"></TrainingResourceCategoryComponent>
                  </div>
                </div>
              </div>
              <div class="col-md-1 d-flex flex-column align-items-center justify-content-center"
                   style="writing-mode: vertical-lr;text-transform: uppercase;font-weight: bold;">
                <h3>{{$t('TrainingResourcesView.agroforestrySystems')}}</h3>
              </div>
            </div>
          </div>

          <div class="rounded border border-brown m-3 p-2  card-beige">
            <div class="row">
              <div class="col-md-11">
                <div class="row">
                  <div class="col-12">
                    <TrainingResourceCategoryComponent
                        v-if="resources !== undefined && resources !== null && resources.constructor === Object"
                        :resources="resources['maize']"
                        :header="$t('TrainingResourcesView.agroecologyInMaize')"
                        :is-editing="isEditing"></TrainingResourceCategoryComponent>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <TrainingResourceCategoryComponent
                        v-if="resources !== undefined && resources !== null && resources.constructor === Object"
                        :resources="resources['wheat']"
                        :header="$t('TrainingResourcesView.agroecologyInWheat')"
                        :is-editing="isEditing"></TrainingResourceCategoryComponent>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <TrainingResourceCategoryComponent
                        v-if="resources !== undefined && resources !== null && resources.constructor === Object"
                        :resources="resources['rice']"
                        :header="$t('TrainingResourcesView.agroecologyInRice')"
                        :is-editing="isEditing"></TrainingResourceCategoryComponent>
                  </div>
                </div>
              </div>
              <div class="col-md-1 d-flex flex-column align-items-center justify-content-center"
                   style="writing-mode: vertical-lr; text-transform: uppercase;font-weight: bold;">
                <h3>{{ $t('TrainingResourcesView.grains')}}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-2 p-1">
        <div class="border border-brown card-yellow" style="min-height:100%;">
          <h2>{{ $t('TrainingResourcesView.whatCanBeDone')}}</h2>
          <p>{{ $t('TrainingResourcesView.whatCanBeDoneText')}}</p>

          <div class="rounded border border-brown m-3 p-2  card-beige">
            <TrainingResourceCategoryComponent
                v-if="resources !== undefined && resources !== null && resources.constructor === Object"
                :resources="resources['strategies']"
                :header="$t('TrainingResourcesView.agroecologicalStrategies')"
                :is-editing="isEditing"></TrainingResourceCategoryComponent>
          </div>

        </div>
      </div>
    </div>
  </div>
  <Footerbar></Footerbar>
</template>

<script>

import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";
import {sharedState} from "@/store";
import {getAllTrainingResources, putTrainingResources} from "@/utils";
import TrainingResourceCategoryComponent from "@/views/training/TrainingResourceCategoryComponent.vue";

export default {
  data() {
    return {
      sharedState,
      message: null,
      messageType: null,
      isEditing: false,
      resources: [],
    };
  },
  components: {
    TrainingResourceCategoryComponent,
    Footerbar,
    Navbar,
  },
  methods: {
    startEditing() {
      this.isEditing = true;
    },
    async saveEdits() {
      this.isEditing = false;
      let response = await putTrainingResources(this.resources);
      if (response.status === 200) {
        this.message = "Changes successfully saved!";
        this.messageType = "success";
      } else {
        this.message = response.response.data.message;
        this.messageType = "danger";
      }
    },

  },
  async mounted() {
    let response = await getAllTrainingResources();
    if (response.status === 200) {
      this.resources = response.data.resources;
    } else {
      this.message = response.response.data.message;
      this.messageType = "danger";
    }
  }
}
</script>

<style scoped>
.card-yellow {
  background-color: #EBB02E !important;
  color: #63432A !important;
}

.card-beige {
  background-color: #E7DBC0 !important;
  color: #63432A !important;
}

.border-brown {
  border: 1px solid #63432A !important;
}
</style>